import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "ヤマト運輸" },
  { value: 2, text: "佐川宅急便" },
]);
